import dev from "./host_dev";
import beta from "./host_beta";
import pre from "./host_pre";
import prod from "./host_prod";

// adgm目前暂无dev与pre环境，后续有的时候更新对应的dev和pre文件即可
export const API_HOSTS = {
  dev,
  beta,
  pre,
  prod,
};
